module.exports = __webpack_public_path__ + "media/images/emblems/Wappen_Arni_AG-42f7295578b7c3d0b89a02b3ecf2157b.svg";